import { render, staticRenderFns } from "./mask-box.vue?vue&type=template&id=719fe4ac&scoped=true&"
import script from "./mask-box.vue?vue&type=script&lang=js&"
export * from "./mask-box.vue?vue&type=script&lang=js&"
import style0 from "./mask-box.vue?vue&type=style&index=0&id=719fe4ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.7.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719fe4ac",
  null
  
)

export default component.exports